/**
 * The switch from Sentinel to CMB Chats (Gary, 18 Oct): the same person's chat when a customer or lead is open,
 * the chat list otherwise. Opens in one named tab, so switching back and forth reuses it.
 */
export const CHATS_WINDOW = 'cmb-chats';

export function chatsUrl(countryCode: string, pathname: string, search: string): string {
  const base = `https://${countryCode.toLowerCase()}.chats.cleanmybed.com/`;
  const customer = /^\/customers\/([0-9a-f-]{36})/.exec(pathname)?.[1]
    ?? (pathname === '/customers' ? new URLSearchParams(search).get('view') ?? undefined : undefined);
  if (customer) return `${base}?customer=${customer}`;
  const lead = pathname.startsWith('/leads') ? new URLSearchParams(search).get('id') : null;
  if (lead && /^[0-9a-f-]{36}$/.test(lead)) return `${base}?lead=${lead}`;
  return base;
}
